export default {
  basicInfo: {
    info: "基本情報",
    permissionName: "役職",
    roleId: "役職",
    memberId: "社員番号",
    kanjiName: "本人氏名",
    bossName: "上司氏名",
  },
  evaluate: "評価項目",
  target: "プロセス目標",
  cards: {
    mission: "ミッション",
    goal: "部署･上司の目標",
    personalGoal: "自身の行動目標",
  },
  detail: "目標詳細",
  building: "種類と達成指標",
  fullValue: "実績・達成度 (四半期終了時)",
  // halfValue: "実績・達成度 (四半期終了時)",
  observation: "観察（課題の抽出と絞り込み）",
  analysis: "分析（原因）",
  judge: "判断（打ち手）",
  targetNumber: "数値目標（達成水準）",
  weight: "ウェイト",
  total: "指標(何を、どの水準に)",
  monthly: "月ごとの実績",
  date: "月度",
  achievement: "打ち手（当月修正・追加事項）",
  score: "自己評価（点数）",
  superiorEvaluation: "上長評価（点数）",
  learnCurrentMonth: "当月学習事項",
  boss: "上司のコメント",
  personal: "できたこと・できなかったこと・ 反省点・次月活かすこと等",
  process: {
    apply: "申請・提出",
    save: "保存",
    submitConfirm: "プロセス目標を上司に申請しますか？",
    submitSuccess: "プロセス目標の申請しました。",
    deleteSuccess: "プロセス目標が削除されました。",
    submitFail: "プロセス目標の申請できなかったです。",
    approveSuccess: "承認しました。",
    approveFail: "承認できなかったです。",
    rejectSuccess: "差し戻しました。",
    rejectFail: "差し戻すことができなかったです。",
  },
  noHasTarget: "個人の目標はまだないです。",
  upload: " 添付ファイル",
};
